import React, { useState, useEffect } from 'react';
import { AlertTriangle, X, Bell, Zap, WifiOff, Power, MessageSquare } from 'lucide-react';

// Componente de Pop-up Crítico para mensajes de CAMMESA
export function CammesaAlertPopup({ mensaje, onClose, onAcknowledge }) {
    const [segundos, setSegundos] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setSegundos(s => s + 1);
        }, 1000);

        // Reproducir sonido de alerta
        const audio = new Audio('data:audio/wav;base64,UklGRnoGAABXQVZFZm10IBAAAAABAAEAQB8AAEAfAAABAAgAZGF0YQoGAACBhYqFbF1fdJivrJBhNjVgodDbq2EcBj+a2teleQ4JK4m84OK1eg0JHYC26/e/Dx8NMYnD5tqnMw0iRoek0d2ROQwtUXiMrc/KlEUjH0tuhJOxurWJPB4lPmF3i5asspthIxstNEJfdJKoxp5rJiIpKDhNYH2RprygdysaJCEqM0RZcIidrLaiaC4cIRseJzJCVGl+jp+urIk7GRIQGBokLDhKYHWJl6WxpH06GxYPEhcaHyovPU9ga3yLmqaxqHwzFBEMDxIUGRwgKTQ/S1lgao2grLGod0YdDA0LDA4QEhQWGiAnMT1GUFpifI6aqKuneUcbDAsKCQoLDQ8REhQWGh4jKjM7Q0xWYG+Fk5+mpX1HGQYDBAMDQQIDBAUHCA==');
        audio.loop = true;
        audio.volume = 0.5;
        audio.play().catch(() => { }); // Ignorar si no se puede reproducir

        return () => {
            clearInterval(interval);
            audio.pause();
        };
    }, []);

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 animate-pulse-slow">
            <div className="bg-red-600 rounded-2xl shadow-2xl max-w-2xl w-full mx-4 overflow-hidden animate-bounce-slow border-4 border-yellow-400">
                {/* Header pulsante */}
                <div className="bg-red-700 p-4 flex items-center justify-between">
                    <div className="flex items-center space-x-3">
                        <div className="relative">
                            <Bell className="w-10 h-10 text-yellow-400 animate-ring" />
                            <span className="absolute -top-1 -right-1 w-4 h-4 bg-yellow-400 rounded-full animate-ping"></span>
                        </div>
                        <div>
                            <h2 className="text-2xl font-black text-white uppercase tracking-wider">
                                ⚠️ MENSAJE CRÍTICO CAMMESA ⚠️
                            </h2>
                            <p className="text-yellow-300 text-sm">Tiempo sin atender: {Math.floor(segundos / 60)}m {segundos % 60}s</p>
                        </div>
                    </div>
                </div>

                {/* Contenido */}
                <div className="p-6 bg-red-600">
                    <div className="bg-white rounded-xl p-6 mb-4">
                        <div className="flex items-start space-x-4">
                            <MessageSquare className="w-12 h-12 text-red-600 flex-shrink-0" />
                            <div>
                                <p className="text-sm text-gray-500 mb-2">
                                    Recibido: {mensaje?.timestamp || new Date().toLocaleString()}
                                </p>
                                <p className="text-2xl font-bold text-gray-900 mb-4">
                                    {mensaje?.texto || 'REDUCIR GENERACIÓN A 500 kW INMEDIATAMENTE'}
                                </p>
                                <p className="text-red-600 font-semibold">
                                    🚨 REQUIERE ACCIÓN INMEDIATA DEL OPERADOR
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Botones */}
                    <div className="flex space-x-4">
                        <button
                            onClick={onAcknowledge}
                            className="flex-1 py-4 px-6 bg-green-500 hover:bg-green-600 text-white font-bold text-lg rounded-xl transition-all transform hover:scale-105 shadow-lg"
                        >
                            ✅ CONFIRMAR RECEPCIÓN
                        </button>
                        <button
                            onClick={onClose}
                            className="py-4 px-6 bg-gray-800 hover:bg-gray-900 text-white font-bold rounded-xl transition-all"
                        >
                            Posponer 5min
                        </button>
                    </div>
                </div>

                {/* Footer */}
                <div className="bg-yellow-400 p-2 text-center">
                    <p className="text-red-800 font-bold text-sm">
                        ⚡ NO ATENDER PUEDE RESULTAR EN MULTA DE CAMMESA ⚡
                    </p>
                </div>
            </div>

            <style>{`
        @keyframes ring {
          0%, 100% { transform: rotate(-15deg); }
          50% { transform: rotate(15deg); }
        }
        @keyframes bounce-slow {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-10px); }
        }
        @keyframes pulse-slow {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.9; }
        }
        .animate-ring { animation: ring 0.5s ease-in-out infinite; }
        .animate-bounce-slow { animation: bounce-slow 2s ease-in-out infinite; }
        .animate-pulse-slow { animation: pulse-slow 1s ease-in-out infinite; }
      `}</style>
        </div>
    );
}

// Panel de Alarmas
function SistemaAlarmas({ mediciones, currentData, onShowCammesaAlert }) {
    const [alarmas, setAlarmas] = useState([]);
    const [mensajesCammesa, setMensajesCammesa] = useState([]);

    // Detectar alarmas basadas en los datos actuales
    useEffect(() => {
        if (!currentData) return;

        const nuevasAlarmas = [];
        const tension = currentData.tension_vab || currentData.tension_l1 || 0;
        const potencia = currentData.kwDesp || 0;

        // Alarma: Generador Parado
        if (tension > 30000 && potencia < 50) {
            nuevasAlarmas.push({
                id: 'gen_parado',
                tipo: 'warning',
                icono: Power,
                titulo: 'GENERADOR PARADO',
                descripcion: 'Línea externa OK pero sin generación',
                timestamp: new Date()
            });
        }

        // Alarma: Corte de Línea
        if (tension < 5000 && tension > 0) {
            nuevasAlarmas.push({
                id: 'corte_linea',
                tipo: 'critical',
                icono: Zap,
                titulo: 'CORTE DE LÍNEA EXTERNA',
                descripcion: `Tensión: ${(tension / 1000).toFixed(2)} kV`,
                timestamp: new Date()
            });
        }

        setAlarmas(nuevasAlarmas);
    }, [currentData]);

    // Simular recepción de mensaje CAMMESA (esto vendría del backend real)
    const simularMensajeCammesa = () => {
        const mensaje = {
            id: Date.now(),
            tipo: 'orden',
            texto: 'REDUCIR GENERACIÓN A 800 kW - Orden de despacho',
            timestamp: new Date().toLocaleString(),
            atendido: false
        };
        setMensajesCammesa(prev => [...prev, mensaje]);
        if (onShowCammesaAlert) {
            onShowCammesaAlert(mensaje);
        }
    };

    const getTipoColor = (tipo) => {
        switch (tipo) {
            case 'critical': return 'bg-red-100 border-red-500 text-red-800';
            case 'warning': return 'bg-yellow-100 border-yellow-500 text-yellow-800';
            default: return 'bg-blue-100 border-blue-500 text-blue-800';
        }
    };

    return (
        <div className="space-y-4">
            {/* Header */}
            <div className="flex items-center justify-between">
                <div className="flex items-center space-x-2">
                    <AlertTriangle className="w-6 h-6 text-red-600" />
                    <h3 className="text-lg font-semibold">Sistema de Alarmas</h3>
                    {alarmas.length > 0 && (
                        <span className="px-2 py-1 text-xs font-bold bg-red-600 text-white rounded-full animate-pulse">
                            {alarmas.length} activas
                        </span>
                    )}
                </div>

                {/* Botón para simular mensaje CAMMESA (para demostración) */}
                <button
                    onClick={simularMensajeCammesa}
                    className="text-xs px-3 py-1 bg-purple-100 text-purple-700 rounded-full hover:bg-purple-200"
                >
                    🧪 Simular Mensaje CAMMESA
                </button>
            </div>

            {/* Lista de Alarmas Activas */}
            {alarmas.length === 0 ? (
                <div className="text-center py-6 bg-green-50 rounded-lg border border-green-200">
                    <div className="w-12 h-12 mx-auto mb-2 bg-green-500 rounded-full flex items-center justify-center">
                        <span className="text-white text-2xl">✓</span>
                    </div>
                    <p className="text-green-700 font-medium">Sin alarmas activas</p>
                    <p className="text-green-600 text-sm">Sistema operando normalmente</p>
                </div>
            ) : (
                <div className="space-y-2">
                    {alarmas.map(alarma => (
                        <div
                            key={alarma.id}
                            className={`p-4 rounded-lg border-l-4 ${getTipoColor(alarma.tipo)} flex items-center justify-between`}
                        >
                            <div className="flex items-center space-x-3">
                                <alarma.icono className="w-6 h-6" />
                                <div>
                                    <p className="font-bold">{alarma.titulo}</p>
                                    <p className="text-sm opacity-80">{alarma.descripcion}</p>
                                </div>
                            </div>
                            <span className="text-xs opacity-60">
                                {alarma.timestamp.toLocaleTimeString()}
                            </span>
                        </div>
                    ))}
                </div>
            )}

            {/* Mensajes CAMMESA pendientes */}
            {mensajesCammesa.filter(m => !m.atendido).length > 0 && (
                <div className="mt-4 p-4 bg-red-600 text-white rounded-lg animate-pulse">
                    <div className="flex items-center space-x-2 mb-2">
                        <Bell className="w-5 h-5" />
                        <span className="font-bold">MENSAJES CAMMESA PENDIENTES</span>
                    </div>
                    {mensajesCammesa.filter(m => !m.atendido).map(m => (
                        <div key={m.id} className="bg-red-500 p-2 rounded mt-1 text-sm">
                            {m.texto}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}

export default SistemaAlarmas;
